import { styled } from '@mui/material/styles';
import {
  Box,
  Card,
  Button,
  Typography,
  Alert
} from '@mui/material';
import {
  FORD_COLORS,
  FORD_TYPOGRAPHY,
  FORD_SPACING,
  FORD_RADIUS,
  FORD_SHADOWS
} from '../../theme/fordTheme.js';

// Main container - full screen with background
export const StyledContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  backgroundColor: FORD_COLORS.backgroundDark,
  color: FORD_COLORS.textLight,
  fontFamily: FORD_TYPOGRAPHY.fallbackFont,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: FORD_SPACING.lg,
  background: `linear-gradient(135deg, ${FORD_COLORS.primaryDark} 0%, ${FORD_COLORS.backgroundDark} 100%)`,
}));

// Login card container
export const StyledLoginCard = styled(Card)(({ theme }) => ({
  backgroundColor: FORD_COLORS.backgroundDark,
  border: `1px solid ${FORD_COLORS.textMuted}`,
  borderRadius: FORD_RADIUS.md,
  padding: FORD_SPACING.xl,
  minWidth: '400px',
  maxWidth: '500px',
  width: '100%',
  boxShadow: FORD_SHADOWS.md,
  textAlign: 'center',

  // Mobile responsive
  '@media (max-width: 600px)': {
    minWidth: 'auto',
    padding: FORD_SPACING.lg,
    margin: '0 10px',
  },
}));

// Main title - Ford Power Monitor
export const StyledMainTitle = styled(Typography)(({ theme }) => ({
  color: FORD_COLORS.textMuted,
  fontSize: FORD_TYPOGRAPHY.h1,
  fontWeight: FORD_TYPOGRAPHY.bold,
  fontFamily: FORD_TYPOGRAPHY.fontFamily,
  marginBottom: FORD_SPACING.md,
  textAlign: 'center',

  '@media (max-width: 600px)': {
    fontSize: FORD_TYPOGRAPHY.h2,
  },
}));

// Subtitle - Sign in with Azure AD
export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: FORD_COLORS.textMuted,
  fontSize: FORD_TYPOGRAPHY.h4,
  fontFamily: FORD_TYPOGRAPHY.fontFamily,
  marginBottom: FORD_SPACING.xl,
  textAlign: 'center',

  '@media (max-width: 600px)': {
    fontSize: FORD_TYPOGRAPHY.body1,
    marginBottom: FORD_SPACING.md,
  },
}));

// Login container
export const StyledLoginContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: FORD_SPACING.md,
  alignItems: 'center',
}));

// Microsoft login button
export const StyledLoginButton = styled(Button)(({ theme }) => ({
  // backgroundColor: FORD_COLORS.secondary,
  color: FORD_COLORS.textColorWhite,
  fontFamily: FORD_TYPOGRAPHY.fontFamily,
  borderRadius: FORD_RADIUS.sm,
  padding: `${FORD_SPACING.md} ${FORD_SPACING.lg}`,
  fontSize: FORD_TYPOGRAPHY.body1,
  fontWeight: FORD_TYPOGRAPHY.medium,
  textTransform: 'none',
  minWidth: '250px',
  height: '48px',
  transition: 'all 0.2s ease-in-out',

  '&:hover': {
    // backgroundColor: FORD_COLORS.primaryLight,
    // boxShadow: FORD_SHADOWS.md,
    transform: 'translateY(-1px)',
    color: FORD_COLORS.textColorWhite,
  },

  '&:disabled': {
    // backgroundColor: FORD_COLORS.textMuted,
    // color: FORD_COLORS.textLight,
    cursor: 'not-allowed',
    transform: 'none',
  },

  '& .MuiButton-startIcon': {
    marginRight: FORD_SPACING.sm,
  },

  '@media (max-width: 600px)': {
    minWidth: '200px',
    fontSize: FORD_TYPOGRAPHY.body2,
    padding: `${FORD_SPACING.sm} ${FORD_SPACING.md}`,
  },
}));

// Error alert
export const StyledErrorAlert = styled(Alert)(({ theme }) => ({
  backgroundColor: FORD_COLORS.errorLight,
  border: `1px solid ${FORD_COLORS.errorDark}`,
  borderRadius: FORD_RADIUS.md,
  color: FORD_COLORS.errorDark,

  '& .MuiAlert-icon': {
    color: FORD_COLORS.errorDark,
  },

  '& .MuiAlert-message': {
    fontSize: FORD_TYPOGRAPHY.fontSizeSM,
  },
}));

// Description text
export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: FORD_COLORS.textMuted,
  fontSize: FORD_TYPOGRAPHY.body2,
  fontFamily: FORD_TYPOGRAPHY.fontFamily,
  lineHeight: 1.5,
  maxWidth: '350px',
  margin: '0 auto',
  textAlign: 'center',

  '@media (max-width: 600px)': {
    fontSize: FORD_TYPOGRAPHY.caption,
    maxWidth: '280px',
  },
}));

// Loading container
export const StyledLoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: FORD_SPACING.sm,
}));
